
import { Inject, Injectable } from '@angular/core';
import { ApiCommonService } from 'cbc-shared-lib';
import { Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';
import { Sgke341aRequest, Sgke341aResponse, Sgke341aService } from 'sg-api';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';
import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';

@Injectable({
  providedIn: 'root'
})
export class UsedSgke341aService {

  /**
   * コンストラクタ
   * @param {Sgke341aService} service
   * @param {ApiCommonService} apiCommonService
   * @param {FeaturesLibConfig} featuresLibcComfig
   * @memberof UsedSgke341aService
   */
  constructor(
    public service: Sgke341aService,
    public apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibcComfig: FeaturesLibConfig
  ) { }

  /**
   * SGKE341A_供給停止結果登録初期表示API呼び出し
   * @param {Sgke341aRequest} request 
   * @returns {Observable<Sgke341aResponse>}
   * @memberof UsedSgke341aService
   */
  public doSgke341a(request: Sgke341aRequest): Observable<Sgke341aResponse> {
    return this.service.sgke341aPost(this.apiCommonService.setRequestCommon(<any>request), 'response')
      .pipe(
        map(
          response => {
            // エラーが設定されていないかチェックする
            this.apiCommonService.checkError(response);
            return response.body;
          }),
        timeout(Number(this.featuresLibcComfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKE341A');
          return throwError(err.message);
        })
      );
  }

}
